import { useCallback } from "react";
import { useLocation } from "wouter";
export function usePortalTransition() {
    const [, setLocation] = useLocation();
    const navigateWithPortal = useCallback((href) => {
        // Navigate immediately - portal effect is handled at App level
        setLocation(href);
    }, [setLocation]);
    return {
        navigateWithPortal
    };
}
